import { Link } from 'react-router-dom';

const LINKS = [
  { label: 'Mentions légales', to: '/mentions-legales' },
  { label: 'Politique de confidentialité', to: '/politique-confidentialite' },
  { label: 'Politique de cookies', to: '/politique-cookies' },
  { label: 'Allergènes', to: '/la-carte#allergenes' },
  { label: 'Contact', to: '/contact' },
];

function InstagramIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17.5" cy="6.5" r="0.5" fill="#fff" stroke="none" />
    </svg>
  );
}

function FacebookIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
    </svg>
  );
}

export default function Footer() {
  return (
    <footer className="footer-root" style={{ backgroundColor: '#000000', boxSizing: 'border-box' }}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0' }}>

        <div style={{ width: 'fit-content' }}>
          <nav className="footer-nav">
            {LINKS.map(({ label, to }) => (
              <Link
                key={to}
                to={to}
                style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '14px', color: '#fff', textDecoration: 'none', whiteSpace: 'nowrap' }}
              >
                {label}
              </Link>
            ))}
          </nav>

          <div style={{ borderTop: '1px solid #333', marginTop: '24px' }} />

          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px', marginTop: '20px' }}>
            <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
              <a href="https://www.instagram.com/fouratacos?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer" aria-label="Instagram" style={{ display: 'flex', alignItems: 'center' }}><InstagramIcon /></a>
              <a href="https://www.facebook.com/fouratacos?locale=fr_FR" target="_blank" rel="noopener noreferrer" aria-label="Facebook" style={{ display: 'flex', alignItems: 'center' }}><FacebookIcon /></a>
              <a href="https://snapchat.com/t/C5QxIHpY" target="_blank" rel="noopener noreferrer" aria-label="Snapchat" style={{ display: 'flex', alignItems: 'center' }}><img src="/snapchat.png" alt="Snapchat" style={{ width: '20px', height: '20px', objectFit: 'contain', filter: 'brightness(0) invert(1)', display: 'block' }} /></a>
            </div>
            <p style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '13px', color: '#fff', margin: 0, whiteSpace: 'nowrap' }}>
              © 2026 Four a Tacos. Tous droits réservés.
            </p>
          </div>
        </div>

      </div>
    </footer>
  );
}
